import { businessKey } from 'queryKeys';

const query = businessKey.query('BidUpdate');

export const status = query.all('status');
export const autoUpdateViaAPI = query.all('auto-update-via-api');
export const errorDetails = query.all('error-details');

export const mutations = query.mutations();

export const setUpdateIsAllowExternalAPI = mutations.mutate(
  'setUpdateIsAllowExternalAPI'
);

export const stopJob = mutations.mutate('stopJob');

export const startJob = mutations.mutate('startJob');

export const downloadErrorFile = mutations.mutate('download-error-file');
